import React from "react"
import { Helmet } from "react-helmet"

export const Seo = ({
  description,
  lang = "en",
  meta = [],
  title,
  image,
  type = "website"
}) => {
  description = description || "Giacomo Bruno is an Italian photographer based in Italy."
  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      title={title}
      titleTemplate={"%s | Giacomo Bruno Photographer"}
      meta={[
        {
          name: "description",
          content: description
        },
        {
          name: "og:description",
          content: description
        },
        {
          name: "og:site_name",
          content: "www.giacomobrunoph.com"
        },
        {
          name: "og:image",
          content: image || "https://www.giacomobrunoph.com/static/media/aboutphoto.736118f8.jpg"
        },
        {
          property: "og:title",
          content: title
        },
        {
          property: "og:description",
          content: description
        },
        {
          property: "og:type",
          content: type
        }
      ].filter(e=>e).concat(meta)}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/Seo.js